import React from "react";
import { useTranslation } from "react-i18next";

import './needHelp.scss'

const NeedHelp = () => {
    const { t } = useTranslation()
    return (
        <div className="container-need-help">
            <div className="texts-need-help">

                <div className="section-text">
                    <h1>{t("chat.need_help.title")}</h1>
                    <p className="text1"> {t("chat.need_help.section_text_1")}</p>
                    <p className="text1"> {t("chat.need_help.section_text_2")}</p>
                    <p> • {t("chat.need_help.section_text_3")}</p>
                    <p> • {t("chat.need_help.section_text_4")}</p>
                    <p> • {t("chat.need_help.section_text_5")}</p>
                    <p> • {t("chat.need_help.section_text_6")}</p>
                    <p> • {t("chat.need_help.section_text_7")}</p>
                    <p> • {t("chat.need_help.section_text_8")}</p>

                    <br />
                    <p> {t("chat.need_help.section_text_9")}</p>
                </div>


                <div className="section-text">
                    <h1>{t("chat.governance.title")}</h1>
                    <p className="text1"> {t("chat.governance.section_text_1")}</p>
                    <p className="text1"> {t("chat.governance.section_text_2")}</p>
                    <p> • {t("chat.governance.section_text_3")}</p>
                    <p> • {t("chat.governance.section_text_4")}</p>
                    <p> • {t("chat.governance.section_text_5")}</p>
                    <p> • {t("chat.governance.section_text_6")}</p>
                </div>
            </div>
        </div>
    )
}

export default NeedHelp